import React from 'react';
import {
  List,
  RichTextField,
  SimpleShowLayout,
  Datagrid,
  DateField,
  ShowButton,
  TextField,
  TextInput,
  Show,
  SelectInput,
  DateInput,
  Filter,
} from 'react-admin';

export const SystemLogsList = props => (
  <List title="System Logs" {...props} sort={{ field: '@timestamp', order: 'desc' }} filters={<ListFilter />}>
    <Datagrid>
      <TextField source="name" sortable={false} />
      <TextField source="levelname" label="Level" />
      <TextField source="msg" label="Message" sortable={false} />
      <DateField source="@timestamp" label="Timestamp" showTime={true} />
      <ShowButton />
    </Datagrid>
  </List>
);

const ListFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <SelectInput
      label="Level"
      allowEmpty={true}
      source="levelname"
      choices={[{ id: 'ERROR', name: 'ERROR' }, { id: 'WARNING', name: 'WARNING' }]}
    />
    <DateInput label="Timestamp Before" source="range.@timestamp.lte" />
    <DateInput label="Timestamp After" source="range.@timestamp.gte" />
  </Filter>
);

export const SystemLogShow = props => (
  <Show title="Log" {...props}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="levelname" label="Level" />
      <RichTextField source="msg" label="Message" />
      <DateField source="@timestamp" label="Timestamp" showTime={true} />

      <TextField source="args" />
      <TextField source="filename" />
      <TextField source="funcName" />
      <TextField source="host" />
      <TextField source="module" />
      <TextField source="pathname" />
    </SimpleShowLayout>
  </Show>
);



// WEBPACK FOOTER //
// ./src/resources/systemlogs.js